const e = "_overlay_2clrk_1", s = "_window_2clrk_14", a = "_modalSlideUp_2clrk_1", _ = "_header_2clrk_47", l = "_close_2clrk_55", c = "_messages_2clrk_69", o = "_message_2clrk_69", r = {
  overlay: e,
  window: s,
  modalSlideUp: a,
  header: _,
  close: l,
  messages: c,
  "messages--date": "_messages--date_2clrk_78",
  message: o,
  "message--avatar": "_message--avatar_2clrk_91",
  "message--details": "_message--details_2clrk_127",
  "message--author": "_message--author_2clrk_135",
  "message--text": "_message--text_2clrk_138",
  "message--time": "_message--time_2clrk_143",
  "loading-container": "_loading-container_2clrk_169"
};
export {
  l as close,
  r as default,
  _ as header,
  o as message,
  c as messages,
  a as modalSlideUp,
  e as overlay,
  s as window
};
